import * as React from "react";
import { CustomLink } from "./CustomLink";

const footerItems = [
  {
    title: "Home",
    link: "https://givefreely.com",
    key: "home"
  },
  {
    title: "About Us",
    link: "https://givefreely.com/about/",
    key: "about"
  },
  {
    title: "Charity Directory",
    link: "/charity-directory/", 
    key: "charity-directory"
  },
  {
    title: "Charity Partners",
    link: "https://givefreely.com/charity-partners/",
    key: "charity-partners"
  },
  {
    title: "Careers",
    link: "https://givefreely.com/careers/",
    key: "careers"
  },
  {
    title: "Contact Us",
    link: "https://givefreely.com/contact-us/",
    key: "contact-us"
  },
  {
    title: "Transparency",
    link: "https://givefreely.com/transparency/",
    key: "transparency"
  },
  {
    title: "Privacy Policy",
    link: "https://givefreely.com/privacy-policy/",
    key: "privacy-policy"
  },
  {
    title: "Terms of Use",
    link: "https://givefreely.com/terms-of-use/",
    key: "terms-of-use"
  }
];
export default function Footer() {
  return (
    <div
      className="h-auto px-2 2xl:mt-28"
      style={{
        width: "100%",
        backgroundColor: "white",
        marginTop: "2rem",
        direction: "flex",
        justifyContent: "center",
        alignItems: "end"
      }}
    >
      <div className="flex flex-wrap justify-center py-2">
        {footerItems?.map((footerItem) => (
          <a href={footerItem.link} className="flex" key={footerItem.key}>
            <span className="mx-2 h-8 cursor-pointer text-sm font-semibold md:h-12">
              {footerItem?.title}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}
